import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5d67dc2d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "btn-primary-yellow btn-addtocart" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseButton = _resolveComponent("BaseButton")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_BaseButton, {
      class: _normalizeClass({'button--primary button--base': !_ctx.isLoading,
  'btn-primary-yellow btn-addtocart button--loading': _ctx.isLoading,'btn-primary-yellow btn-addtocart button--success': _ctx.displaySuccess}),
      type: "button",
      onClick: _ctx.onClick,
      disabled: _ctx.isLoading || _ctx.displaySuccess
    }, {
      default: _withCtx(() => [
        (!_ctx.isLoading && !_ctx.displaySuccess)
          ? (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(_ctx.$t("Cart.AddToCart")), 1))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["class", "onClick", "disabled"]),
    _hoisted_2
  ], 64))
}